// removed by extract-text-webpack-plugin
module.exports = {"container":"styles--container--2qdfYVDx","image":"styles--image--1eewW-bS","title":"styles--title--ufIgR61O","image-container":"styles--image-container--3ukML8Q8","imageContainer":"styles--image-container--3ukML8Q8","bubble":"styles--bubble--24O5MB03","text-container":"styles--text-container--2P-J7eXa","textContainer":"styles--text-container--2P-J7eXa","subtitle":"styles--subtitle--2Wo-E1qS","actions":"styles--actions--1RVDlhae"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Card/styles.css
// module id = 1330
// module chunks = 2